import { register } from '../component.js';
import 'react';
import 'react/jsx-runtime';

var _socialIcons_ravelry = register("ravelry", {"color":"#EE6E62","path":"M0 0h64v64H0Zm42.692 28.943s-2.184-.397-3.752-.397c-3.584 0-4.424 1.987-4.424 4.939v12.488H24.83V20.542h9.687v4.257c1.176-3.576 3.528-4.825 8.176-4.825z"});

export { _socialIcons_ravelry as default };
